// src/components/layout/AdminHeader/AdminHeader.tsx
import React, { useEffect, useState } from 'react';
import { FiMenu, FiLogOut, FiUser } from 'react-icons/fi';
import { useAuth } from '../../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../common/LanguageSelector/LanguageSelector';
import styles from './AdminHeader.module.css';

const ClockDisplay: React.FC = () => {
  const [time, setTime] = useState('');
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const langCode = i18n.language.split('-')[0];

      const localTime = now.toLocaleTimeString(langCode === 'es' ? 'es-MX' : 'en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      setTime(localTime);
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000);
    return () => clearInterval(intervalId);
  }, [i18n.language]);

  return <span className={styles.clock}>{time}</span>;
};

interface AdminHeaderProps {
  onMenuToggle: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onMenuToggle }) => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();

  const firstName = user?.name?.split(' ')[0] || t('common.admin');
  const roleKey =
    user?.role === 'manager'
      ? 'profile.user_role_manager'
      : user?.role === 'admin'
        ? 'profile.user_role_admin'
        : user?.role === 'developer'
          ? 'profile.user_role_developer'
          : user?.role === 'client'
            ? 'profile.user_role_client'
            : 'profile.user_role_admin';

  return (
    <header className={styles.header}>
      <div className={styles.leftGroup}>
        <button onClick={onMenuToggle} aria-label={t('common.toggleMenu')} className={styles.menuButton} type="button">
          <FiMenu />
        </button>
        <ClockDisplay />
      </div>

      <div className={styles.rightGroup}>
        <LanguageSelector />

        <div className={styles.userInfo}>
          <span className={styles.greeting}>{t('layout.welcome', { name: firstName })}</span>
          <span className={styles.role}>{t(roleKey)}</span>
        </div>

        <div className={styles.avatar} aria-hidden="true">
          <FiUser />
        </div>

        <button onClick={() => logout()} title={t('common.logout')} aria-label={t('common.logout')} className={styles.logout} type="button">
          <FiLogOut />
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
